function echbPostCardTemplate(post, scAttrBrandId) {
  const urlParams = new URLSearchParams(window.location.search);
  const cateId = parseInt(urlParams.get("cate_id")) || "";
  const tagId = parseInt(urlParams.get("tag_id")) || "";
  const thumbnailArrEn = JSON.parse(post.en_blog_img);
  const thumbnailArrZh = JSON.parse(post.tc_blog_img);
  const thumbnailArrSc = JSON.parse(post.cn_blog_img);
  if (!thumbnailArrZh[0]) {
    thumbnailArrZh[0] =
      "https://rehealth-eshop.myshopify.com/cdn/shop/files/rehealth.svg";
  }

  const publishDate = new Date(post.product_time * 1000).toLocaleDateString(
    "en-GB"
  );

  /***** CATEGORY *****/
  const cateArrEn = [];
  const cateArrZh = [];
  const cateArrSc = [];

  if (Array.isArray(post.category)) {
    post.category.forEach((label) => {
      cateArrEn.push({
        type: "category",
        tag_id: label.article_category_id,
        tag_name: label.en_name,
      });
      cateArrZh.push({
        type: "category",
        tag_id: label.article_category_id,
        tag_name: label.tc_name,
      });
      cateArrSc.push({
        type: "category",
        tag_id: label.article_category_id,
        tag_name: label.cn_name,
      });
    });
  }
  /***** (END) CATEGORY *****/

  /***** TAG *****/
  const tagsArrEn = [];
  const tagsArrZh = [];
  const tagsArrSc = [];

  if (Array.isArray(post.label)) {
    post.label.forEach((label) => {
      tagsArrEn.push({
        type: "tag",
        tag_id: label.label_id,
        tag_name: label.en_name,
      });
      tagsArrZh.push({
        type: "tag",
        tag_id: label.label_id,
        tag_name: label.tc_name,
      });
      tagsArrSc.push({
        type: "tag",
        tag_id: label.label_id,
        tag_name: label.cn_name,
      });
    });
  }
  /***** (END) TAG *****/

  return `
          <div class="single_blog_post_card">
              <div class="post_thumb">
                  <a href="/blogs/health-news/health-blog-content/?article_id=${post.forever_article_id}&post_version=${post.forever_version}&scAttr_brand_id=${scAttrBrandId}">
                      <img src="${strEcholang([
                        thumbnailArrEn[0],
                        thumbnailArrZh[0],
                        thumbnailArrSc[0],
                      ])}" />
                  </a>
              </div>
              <div class="post_title">
                  <a href="/blogs/health-news/health-blog-content/?article_id=${post.forever_article_id}&post_version=${post.forever_version}&scAttr_brand_id=${scAttrBrandId}">
                      ${strEcholang([
                        post.en_title,
                        post.tc_title,
                        post.cn_title,
                      ])}
                  </a>
              </div>
              <div class="post_date">${publishDate}</div>
              <div class="post_cate">
                  <strong>${strEcholang([
                    "Categories",
                    "類別",
                    "类别",
                  ])}: </strong>
                  ${strEcholang([echbApplyCommaFromArray(cateArrEn, scAttrBrandId), echbApplyCommaFromArray(cateArrZh, scAttrBrandId), echbApplyCommaFromArray(cateArrSc, scAttrBrandId)])}
              </div>
              <div class="post_tag">
                  <strong>${strEcholang([
                    "Tags",
                    "標籤",
                    "标签",
                  ])}: </strong>
                  ${strEcholang([echbApplyCommaFromArray(tagsArrEn, scAttrBrandId), echbApplyCommaFromArray(tagsArrZh, scAttrBrandId), echbApplyCommaFromArray(tagsArrSc, scAttrBrandId)])}
              </div>
          </div>
      `;
}
function echbApplyCommaFromArray(dataArr, scAttrBrandId) {
  let prefix = "";
  let commaList = "";
  const urlParams = new URLSearchParams(window.location.search);
  const tagId = parseInt(urlParams.get("tag_id"));
  const cateId = parseInt(urlParams.get("cate_id"));
  
  scAttrBrandId = String(scAttrBrandId).trim();
  dataArr.forEach((itemArr) => {
    let type = itemArr.type === "tag" ? "tag_id=" : "cate_id=";
    let url = `/blogs/health-news/health-blog-category-tag-list?brand_id=${scAttrBrandId}&${type}${itemArr.tag_id}`;
    if (itemArr.type === "tag") {
      commaList += `${prefix}<span class="echb_tag"><a href="${url}">#${itemArr.tag_name}</a></span>`;
    } else {
      commaList += `${prefix}<a href="${url}">${itemArr.tag_name}</a>`;
    }

    prefix = ", ";
  });
  
  return commaList;
}
function ecbDisplayPostContent(contentLangArr) {
    const contentArr = strEcholang(contentLangArr);
    let html = '';

    contentArr.forEach((data, key) => {
        data.title = data.title || contentLangArr[1][key]?.title || '';
        data.content = data.content || contentLangArr[1][key]?.content || '';
        data.desktop_img = data.desktop_img || contentLangArr[1][key]?.desktop_img || '';
        data.mobile_img = data.mobile_img || contentLangArr[1][key]?.mobile_img || '';

        html += `<div class="ECHB_p_section">
                    <h2>${data.title}</h2>
                    <p>${data.content}</p>`;

        if (data.desktop_img) {
            html += `<img src="${data.desktop_img}" class="hidden_b_w1024" />`;
        }

        if (data.mobile_img) {
            html += `<img src="${data.mobile_img}" class="show_b_w1024" />`;
        }

        html += `</div>`;
    });

    return html;
}
function echbSortContentArr(contentArr) {
    contentArr = Object.values(contentArr);
    contentArr.sort((a, b) => {
        if (a.sort === "") return 1;
        if (b.sort === "") return -1;
        return a.sort - b.sort;
    });

    let footerArr = null;
    contentArr = contentArr.filter(item => {
        if (item.part === "FOOTER") {
            footerArr = item;
            return false;
        }
        return true;
    });

    if (footerArr) {
        contentArr.push(footerArr);
    }

    return contentArr;
}

function echBlogPosts(params) {
  const { page, pageSize, brandId, tagId, cateId } = params;
  const apiUrl = `/blog_article_list?page=${page}&page_size=${pageSize}&channel_id=9&get_type=1&brand_id=${brandId}&label_id=${tagId}&article_category_id=${cateId}`;
  
  getECHBlogJson(apiUrl).then((data) => {
    if (!data) {
      document.querySelector(".ech_blog_container").innerHTML =
        "<p>無法載入文章</p>";
      return;
    }
    const echBlogBigWrap = document.querySelector(".ech_blog_big_wrap");
    const blogListContainer = document.querySelector(".ech_blog_container");
    const totalPages = Math.ceil(data.count / pageSize);
    blogListContainer.innerHTML = "";
    let searchTagStr="";
    let articleHTML = `<div class="all_posts_container" data-ppp="${pageSize}" data-brand-id="${brandId}">`;
    data.result.forEach((article) => {
      if(tagId){
        searchTagStr = searchTagOrCategory('tag', tagId, article);
      }else if(cateId){
        searchTagStr = searchTagOrCategory('category', cateId, article);
      }
      articleHTML += echbPostCardTemplate(article, brandId);
    });
    const pageTitle = document.querySelector("#pageTitle");
    if(pageTitle && tagId){
      pageTitle.innerHTML = `${strEcholang(["Tags", "標籤","标签"])}: ${searchTagStr}`;
    }else if(pageTitle && cateId){
      pageTitle.innerHTML = `${strEcholang(["Categories", "類別", "类别"])}: ${searchTagStr}`;
    }
    articleHTML += "</div>";
    blogListContainer.innerHTML = articleHTML;

    updatePagination(page, pageSize, brandId, totalPages);
  });
}

function searchTagOrCategory(type, typeId, article) {
  let target = (type === 'tag') ? article.label.find(label => parseInt(label.label_id) === typeId) : article.category.find(category => parseInt(category.article_category_id) === typeId);
  if (!target) return "";
  let translatedName = strEcholang([target.en_name, target.tc_name, target.cn_name]);
  return type === 'tag' ? `#${translatedName}` : translatedName;
}

function getECHBlogJson(url) {
  const apiUrlBase = "https://globalcms-api.umhgp.com/v1/api";
  url = apiUrlBase + url;
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      version: "v1",
    },
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error fetching data:", error);
      return null;
    });
}
function updatePagination(currentPage, pageSize, brandId, totalPages) {
  const paginationContainer = document.querySelector(".pagination__list");
  if (!paginationContainer) return;

  paginationContainer.dataset.currentPage = currentPage;
  paginationContainer.dataset.maxPage = totalPages;
  paginationContainer.dataset.brandId = brandId;

  const range = pageRange(currentPage, totalPages);
  let paginationHTML = "";

  if (currentPage > 1) {
    paginationHTML += `<li><a class="pagination__item pagination__item-arrow link" data-page="${currentPage - 1}" href="?page=${currentPage - 1}">&lt;</a></li>`;
  }

  for (let page = range.start; page <= range.end; page++) {
    if( page === currentPage ){
      paginationHTML += `<li><a class="pagination__item pagination__item--current" data-page="${page}">${page}</a></li>`;
    }else{
      paginationHTML += `<li><a class="pagination__item link" data-page="${page}" href="?page=${page}">${page}</a></li>`;
    }
  }

  if (currentPage < totalPages) {
    paginationHTML += `<li><a class="pagination__item pagination__item-arrow link" data-page="${currentPage + 1}" href="?page=${currentPage + 1}">&gt;</a></li>`;
  }
  paginationContainer.innerHTML = paginationHTML;
}

function pageRange(page, pageCount) {
  let start = parseInt(page) - 2;
  let end = parseInt(page) + 2;
  if (end > pageCount) {
    start -= end - pageCount;
    end = pageCount;
  }
  if (start <= 0) {
    end += (start - 1) * -1;
    start = 1;
  }
  end = end > pageCount ? pageCount : end;

  return { start, end };
}
function strEcholang(stringArr) {
  const lang = document.documentElement.lang || "zh-TW";
  let langIndex = { "zh-TW": 1, "zh-CN": 2, en: 0 }[lang] ?? 0;
  return stringArr[langIndex] || stringArr[1] || "";;
}

